'use client';
import Banner from '@src/components/landing-sections/banner';
import Dreps from '@src/components/landing-sections/dreps';
import FAQ from '@src/components/landing-sections/faq';
import Features from '@src/components/landing-sections/features';
import GetStarted from '@src/components/landing-sections/getStarted';
import HowItWorks from '@src/components/landing-sections/howItWorks';
import withWalletEventListener from '@src/walletEvent/walletStateUtils';

// This page previously withheld all of its content until an `isMounted` flag
// flipped on the client, so the server sent a spinner and nothing else — the
// entire homepage was invisible to crawlers. None of the sections below read
// `window`, storage or the clock during render, so there is no hydration
// mismatch to guard against; the components that genuinely depend on client
// state (the navbar's wallet controls) carry their own guards.
//
// `explore` arrives as a slot rather than an import because it is a server
// component: anything imported from inside this `'use client'` boundary would
// be compiled into the client bundle, and that section is static markup.
function HomeSections({ explore }: { explore: React.ReactNode }) {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center">
      <Banner />
      <Dreps />
      {explore}
      <Features />
      <HowItWorks />
      <FAQ />
      <GetStarted />
    </div>
  );
}

export default withWalletEventListener(HomeSections);
